// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T47H","top":"styles_top__2x3I5","left":"styles_left__1tg-4","description":"styles_description__2AZ30"};